angular.module('impactx.userdialog').controller('UserControlSettingsCtrl', ['$scope', 'dataGen', 'ControlRelationService', UserControlSettingsCtrl]);

function UserControlSettingsCtrl($scope, dataGen, ControlRelationService) {
    var ctrl = this;
    $scope.search = {value: ""};
    $scope.defaultControlEntriesMayHaveChanged = {value: false};

    $scope.shown = false;
    $scope.loaded = false;

    this.toggleControl = function () {
        if(!$scope.loaded) {
            this.loadData();
        }
        $scope.shown = !$scope.shown;
    };

    this.loadData = function () {
        dataGen.getData({}, { id: $scope.usrId, type: $scope.name }, "/user/control/setting/view").then(function (response) {
            if(!$scope.loaded && response.data) {
                ControlRelationService.setControlDataToScope($scope.object, response.data.relation);
                $scope.relation.defaultControl = response.data.relation.defaultControl;
                $scope.settings = response.data.settings;
                ctrl.setDefaultAndReadOnlyControlDataToScope($scope.object);
                ctrl.filterReadOnly();
                $scope.loaded = true;
            }
        });
    };

    this.indexOfControl = function(array, control) {
        for(var i = 0; i < array.length; i++) {
            if(array[i].id == control.id) {
                return i;
            }
        }
        return -1;
    };

    this.setDefaultAndReadOnlyControlDataToScope = function(scopeObject) {
        var merged = scopeObject.readOnlyRelation.assigned.concat(scopeObject.assignedRelation.assigned);
        for (var j = 0; j < scopeObject.readOnlyRelation.assigned.length; j++) {
            scopeObject.readOnlyRelation.assigned[j].isDenied = undefined;
        }
        for (var i = 0; i < scopeObject.deniedRelation.assigned.length; i++) {
            var index = ctrl.indexOfControl(merged, scopeObject.deniedRelation.assigned[i]);
            if (index >= 0) {
                merged.splice(index, 1);
            }
            var indexReadOnly = ctrl.indexOfControl(scopeObject.readOnlyRelation.assigned, scopeObject.deniedRelation.assigned[i]);
            if (indexReadOnly >= 0) {
                scopeObject.readOnlyRelation.assigned[indexReadOnly].isDenied = true;
            }
        }

        if ($scope.relation.defaultControl.selected && ctrl.indexOfControl(merged, $scope.relation.defaultControl.selected) < 0) {
            $scope.relation.defaultControl.selected = {};
        }
        scopeObject.defaultControl = {entries: merged};
    };

    $scope.$watch(function() {
            return $scope.defaultControlEntriesMayHaveChanged.value;
        },
        function(newValue, oldValue) {
            if($scope.loaded && newValue && newValue != oldValue) {
                ctrl.setDefaultAndReadOnlyControlDataToScope($scope.object);
                $scope.defaultControlEntriesMayHaveChanged.value = false;
            }
        });

    this.filterReadOnly = function()
    {
        if ($scope.search.value != undefined && $scope.search.value.length>0)
        {
            var r =  new RegExp($scope.search.value.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'), 'i');
            $scope.filteredReadOnly = $scope.object.readOnlyRelation.assigned.filter(function(el)
            {
                return r.test(el.value);
            });
        }
        else
        {
            $scope.filteredReadOnly = $scope.object.readOnlyRelation.assigned;
        }
    };
}